<template>
  <div :class="{ nav: artist_role }" v-if="user">
    <Admin v-if="admin_role" />
    <Artist v-if="artist_role" />
    <Label v-if="label_role" />
    <Content v-if="content_role" />
    <Mcn v-if="mcn_role" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    Admin: () => import('./Admin'),
    Artist: () => import('./Artist'),
    Label: () => import('./Label'),
    Content: () => import('./Content'),
    Mcn: () => import('./Mcn')
  },

  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', [
      'admin_role',
      'artist_role',
      'label_role',
      'content_role',
      'mcn_role'
    ])
  }
}
</script>

<style scoped>
.nav {
  margin-left: 300px;
}
</style>
